<card-alerte *ngIf="alertes?.listeAlertes?.length" [niveau]="alertes?.niveau" [isCard]="true">
    <preview-alerte *ngFor="let alerte of alertes?.listeAlertes" [alerte]="alerte" [translateAlerte]="true"></preview-alerte>
</card-alerte>

<form #form="ngForm">
    <mat-card>
        <mat-card-title>
            <span [translate]="'admin.entreprise.utilisateurs.detail.generalites.infosGenerales.title'"></span>
        </mat-card-title>
        <mat-card-content>
            <div class="row align-items-center">
                <custom-input
                        ngDefaultControl
                        id="civilite"
                        name="civilite"
                        customType="select"
                        [lCol]="2" [rCol]="4"
                        [(ngModel)]="user.genre"
                        [libelle]="'admin.entreprise.utilisateurs.detail.generalites.infosGenerales.civilite'"
                        [selectOptions]="listeTypeGenre"
                        optionDisplay="libelle"
                        optionValue="code"
                        [readonly]="isReadOnly">
                </custom-input>
                <label class="col-md-2">
                    <span [translate]="'admin.entreprise.utilisateurs.detail.generalites.infosGenerales.actif'"></span>
                </label>
                <div class="col-md-4">
                    <button mat-button color="primary" (click)="onClickActif()" [disabled]="isReadOnly" class="button-input">
                        <span *ngIf="!user.actif" [translate]="'confirmation.non'"></span>
                        <span *ngIf="user.actif && user.dateIn && user.dateOut && moment().isBetween(user.dateIn,user.dateOut,'day','[]')"
                              [translate]="'admin.entreprise.utilisateurs.detail.generalites.infosGenerales.actifOuiDuAu'"
                              [translateParams]="{ dateIn: user.dateIn | date:'shortDate',dateOut: user.dateOut | date:'shortDate' }"></span>
                        <span *ngIf="user.actif && user.dateIn && !user.dateOut && moment().isSameOrAfter(user.dateIn,'day')"
                              [translate]="'admin.entreprise.utilisateurs.detail.generalites.infosGenerales.actifOuiDepuis'" [translateParams]="{ dateIn: user.dateIn | date:'shortDate' }"></span>
                        <span *ngIf="user.actif && !user.dateIn && user.dateOut && moment().isSameOrBefore(user.dateOut,'day')"
                              [translate]="'admin.entreprise.utilisateurs.detail.generalites.infosGenerales.actifOuiJusquAu'" [translateParams]="{ dateOut: user.dateOut | date:'shortDate' }"></span>
                        <span *ngIf="user.actif && (!user.dateIn && !user.dateOut || moment().isBefore(user.dateIn,'day') || moment().isAfter(user.dateOut,'day'))"
                              [translate]="'confirmation.oui'"></span>
                        <mat-icon color="primary">search</mat-icon>
                    </button>
                </div>
            </div>
            <div class="row">
                <custom-input
                        ngDefaultControl
                        id="nom"
                        name="nom"
                        customType="input"
                        [(ngModel)]="user.nom"
                        libelle="admin.entreprise.utilisateurs.detail.generalites.infosGenerales.nom"
                        [maxlength]="100"
                        [required]="true"
                        [readonly]="isReadOnly">
                </custom-input>
                <custom-input
                        ngDefaultControl
                        id="matricule"
                        name="matricule"
                        customType="input"
                        [(ngModel)]="user.matricule"
                        libelle="admin.entreprise.utilisateurs.detail.generalites.infosGenerales.matricule"
                        [maxlength]="10"
                        [required]="true"
                        [readonly]="isReadOnly || user.idUser > 0">
                </custom-input>
            </div>
            <div class="row">
                <custom-input
                        ngDefaultControl
                        id="prenom"
                        name="prenom"
                        customType="input"
                        [(ngModel)]="user.prenom"
                        libelle="admin.entreprise.utilisateurs.detail.generalites.infosGenerales.prenom"
                        [maxlength]="100"
                        [required]="true"
                        [readonly]="isReadOnly">
                </custom-input>
                <custom-input
                        ngDefaultControl
                        id="email"
                        name="email"
                        customType="input"
                        [(ngModel)]="user.email"
                        libelle="admin.entreprise.utilisateurs.detail.generalites.infosGenerales.email"
                        [maxlength]="100"
                        [required]="true"
                        [readonly]="isReadOnly"
                        email>
                </custom-input>
            </div>
            <div class="row">
                <custom-input
                        ngDefaultControl
                        id="nomAcces"
                        name="nomAcces"
                        customType="input"
                        [(ngModel)]="user.nomAcces"
                        libelle="admin.entreprise.utilisateurs.detail.generalites.infosGenerales.nomAcces"
                        [maxlength]="500"
                        [required]="true"
                        [readonly]="isReadOnly">
                </custom-input>
                <custom-input
                        ngDefaultControl
                        id="affectation"
                        name="affectation"
                        customType="autocomplete"
                        [autocompleteFilter]="{ isAffectable: true, isShowAllAffectable: true }"
                        [autocompleteExtraOptions]="{ isSearchTypeSelectable: true }"
                        [(ngModel)]="user.orga"
                        libelle="admin.entreprise.utilisateurs.detail.generalites.infosGenerales.affectation"
                        autocompleteType="service"
                        optionValue="idOrga"
                        optionDisplay="libelle"
                        [idName]="'idOrga'"
                        (onChange)="onOrgaChange()"
                        [required]="true"
                        [readonly]="isReadOnly">
                </custom-input>
            </div>
            <div class="row" *ngIf="user.idUser">
                <label class="col-md-2">
                    <span [translate]="'admin.entreprise.utilisateurs.detail.generalites.infosGenerales.motDePasse'"></span>
                </label>
                <div class="col-md-4">
                    <button mat-button color="primary" (click)="onClickPassword()" [disabled]="isReadOnly" class="button-input">
                        <span [translate]="user.passExpirationDate ? 'admin.entreprise.utilisateurs.detail.generalites.infosGenerales.expiration' : 'admin.entreprise.utilisateurs.detail.generalites.infosGenerales.activer'"
                              [translateParams]="{ date: user.passExpirationDate | date: 'shortDate' }"></span>
                        <mat-icon color="primary">search</mat-icon>
                    </button>
                </div>
                <label class="col-md-2" *ngIf="!user.actif && (!user.dateOut || user.statutOubli === StatutOubli.PROGRAMME || user.statutOubli === StatutOubli.EN_ATTENTE || user.statutOubli === StatutOubli.OUBLIE)">
                    <span [translate]="'admin.entreprise.utilisateurs.internes.eligibleOubli.title'"></span>
                </label>
                <div class="col-md-4 p-t-10" *ngIf="!user.actif && (!user.dateOut || user.statutOubli === StatutOubli.PROGRAMME || user.statutOubli === StatutOubli.EN_ATTENTE || user.statutOubli === StatutOubli.OUBLIE)">
                    <span *ngIf="!user.dateOut" [translate]="'admin.entreprise.utilisateurs.internes.eligibleOubli.sansDateSortie'"></span>
                    <ng-container *ngIf="user.dateOut">
                        <span *ngIf="user.statutOubli === StatutOubli.PROGRAMME">{{ 'admin.entreprise.utilisateurs.internes.eligibleOubli.programme' | translate:{date: user.dateStatutOubli | date:'shortDate'} }}</span>
                        <span *ngIf="user.statutOubli === StatutOubli.EN_ATTENTE">{{ 'admin.entreprise.utilisateurs.internes.eligibleOubli.attente' | translate:{date: user.dateStatutOubli | date:'shortDate'} }}</span>
                        <span *ngIf="user.statutOubli === StatutOubli.OUBLIE">{{ 'admin.entreprise.utilisateurs.internes.eligibleOubli.oublie' | translate:{date: user.dateStatutOubli | date:'shortDate'} }}</span>
                    </ng-container>
                </div>
            </div>

            <div class="row" *ngIf="user.idUser">
                <label class="col-md-2 align-items-start p-t-15">
                    <span [translate]="'admin.entreprise.utilisateurs.detail.generalites.infosGenerales.commentaire'"></span>
                </label>
                    <custom-input ngDefaultControl floatLabel="always" rCol="9" class="col-md-9"
                              [(ngModel)]="user.commentaire"
                              id="commentaire" name="commentaire"
                              customType="textarea"
                              maxlength="2000"
                              [readonly]="isReadOnly"
                    ></custom-input>
            </div>

        </mat-card-content>
    </mat-card>
</form>

<list-view *ngIf="listeHabilitations && isDroitHabilitations" [liste]="listeHabilitations"></list-view>

<list-view *ngIf="listeDelegationRecue && isDroitHabilitations" [liste]="listeDelegationRecue"></list-view>

<list-view *ngIf="listeDelegationAccordee && isDroitHabilitations" [liste]="listeDelegationAccordee"></list-view>

<floating-button *ngIf="listeActions" [listeActions]="listeActions" [isPending]="isPending"></floating-button>
